<template>
  <Layout>
    <Card class="w-full">
      <template slot="header">
        <div
          class="is-flex is-justify-content-space-between w-full is-align-items-center"
        >
          <div class="is-size-4 has-text-weight-bold">Productos</div>
          <Button
            tag="router-link"
            :to="{ name: 'product_create' }"
            variant="main"
            >Crear</Button
          >
        </div>
      </template>
      <template slot="content">
        <div class="filterContainer">
          <b-field label="Buscar: ">
            <b-input
              placeholder="Buscar..."
              class="inputSearch"
              v-model="query.search"
              type="search"
              icon="search"
              @keyup.native="searchInput"
            >
            </b-input>
          </b-field>
        </div>

        <b-table
          :data="results"
          detail-key="id"
          icon-pack="fas"
        >
          <b-table-column field="name" label="Imagen" v-slot="props">
            <img
              :src="props.row.image"
              :alt="props.row.name"
              style="max-width: 100px;"
            />
          </b-table-column>
          <b-table-column field="name" label="Nombre" v-slot="props">
            <router-link
              :to="{ name: 'product_update', params: { id: props.row.id } }"
              class="has-text-weight-semibold"
              >{{ props.row.name }}</router-link
            >
          </b-table-column>
          <b-table-column field="price" label="Precio" v-slot="props">
            <span>S/. {{ props.row.price }}</span>
          </b-table-column>
          <b-table-column field="shipping_cost" label="Activo" v-slot="props">
            <font-awesome-icon
              v-if="props.row.is_active"
              :icon="['fas', 'check']"
              class="has-text-success"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'times']"
              class="has-text-danger"
            />
          </b-table-column>
          <b-table-column field="price" label="Idiomas" v-slot="props">
            <span
              @click="openModalLanguage(props.row.id)"
              class="has-text-weight-semibold has-text-primary"
              style="cursor: pointer"
            >
              Inglés
              <font-awesome-icon :icon="['fas', 'pen']" class="ml-1" />
            </span>
          </b-table-column>
        </b-table>
        <hr style="margin-top: 0;" />
        <Page
          :links="links"
          :pages="pages"
          v-if="pages"
          @set-link="setLink"
          @set-page="setPage"
        ></Page>
      </template>
    </Card>
    <ModalLanguage
      v-if="modalLanguage"
      @hidden="modalLanguage = false"
      @reload="getDataAPI()"
      :idProduct="idProduct"
    />
  </Layout>
</template>
<script>
import Layout from '@/components/Layout'
import Button from '@/components/form/Button'
import Card from '@/components/base/Card'
import Page from '@/components/Pages'
import ProductService from '@/services/ProductService'
import ModalLanguage from '@/components/product/ModalLanguage'
export default {
  name: 'ProductList',
  components: {
    Layout,
    Button,
    Card,
    Page,
    ModalLanguage
  },
  data() {
    return {
      checkedRows: [],
      query: {
        search: ''
      },
      results: [],
      links: {},
      pages: {},
      loading: true,
      modalLanguage: false,
      idProduct: 0
    }
  },
  created() {
    this.getDataAPI({})
  },
  methods: {
    openModalLanguage(id) {
      this.idProduct = id
      this.modalLanguage = true
    },
    async getDataAPI(params) {
      this.loading = true
      try {
        const response = await ProductService.getList(params)
        this.results = response.data.results
        this.pages = response.data.pages
        this.links = response.data.links
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    searchInput() {
      if (this.query.search !== null) {
        if (this.query.search.length >= 3) {
          this.getDataAPI({ ...this.query })
        } else if (this.query.search.length === 0) {
          this.query.search = null
          this.getDataAPI({ ...this.query })
        }
      }
    },
    setLink() {
      this.getDataAPI({})
    },
    setPage(page) {
      this.getDataAPI({ ...this.query, page: page })
    }
  }
}
</script>
